
import axios from 'plugins/axios';

import {
    HomeFilled,
    User,
    Pointer,
    View,
    SetUp,
    CreditCard,
    Calendar,
    TakeawayBox,
    Orange,
    Setting,
    DataAnalysis,
    DataBoard,
    Warning,
    MuteNotification
} from '@element-plus/icons-vue';
import { shallowRef } from 'vue';

export function getToken() {
    return localStorage.getItem('authToken');
}

export function setToken(token) {
    return localStorage.setItem('authToken', token);
}

export function removeToken() {
    return localStorage.removeItem('authToken');
}

export const superAdmins = [
    '0332040', // 周栗刚
    '0206236', // 葛真瑀
    '0172779', // 宋彬彬
    '0290572', // 李方飞
    '0160395', // 李阳
    '0029921' // 裴艳丽
];

export const iconConfig = shallowRef({
    '/task': TakeawayBox,
    '/question': Orange,
    '/waitDeal': SetUp,
    '/propose': Pointer,
    '/lookView': View,
    '/echart': Calendar,
    '/setting': Setting,
    '/pageHome': HomeFilled,
    '/manage': User,
    '/target': CreditCard,
    '/project': Calendar,
    '/budgetBoard': DataAnalysis,
    '/needsBoard': DataBoard,
    '/warningBoard': Warning,
    '/operateBoard': MuteNotification

});

export const routerList = [
    {
        url: '/task',
        name: '会议任务'
    },
    {
        url: '/question',
        name: '专项问题'
    },
    {
        url: '/waitDeal',
        name: '待处理'
    },
    {
        url: '/propose',
        name: '发起'
    },
    {
        url: '/lookView',
        name: '查看'
    },
    {
        url: '/setting',
        name: '设置'
    },
    {
        url: '/pageHome',
        name: '首页'
    },
    {
        url: '/manage',
        name: '管理'
    },
    {
        url: '/target',
        name: '目标'
    },
    {
        url: '/project',
        name: '项目'
    },
    {
        url: '/setting',
        name: '设置'
    },
    {
        url: '/budgetBoard',
        name: '预算'
    },
    {
        url: '/needsBoard',
        name: '需求'
    },
    {
        url: '/warningBoard',
        name: '预警'
    },
    {
        url: '/operateBoard',
        name: '运维'
    }
];

export const getWechatConfig = async() => {
    const res = await axios({
        url: '/wechat/config',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: location.href.split('#')[0]
    });
    const res2 = await axios({
        url: 'wechat/js/config',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: location.href.split('#')[0]
    });
    const { data } = res;
    const { data: data2 } = res2;
    wx?.config({
        beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，企业微信的corpID，必须是本企业的corpID，不允许跨企业使用
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: ['openEnterpriseChat', 'chooseImage', 'onMenuShareAppMessage'], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        fail: function(res) {
            console.log(res);
            // cons(JSON.stringify(res));
        }
    });
    wx?.agentConfig({
        corpid: data2.appId, // 必填，企业微信的corpid，必须与当前登录的企业一致
        agentid: data2.agentId, // 必填，企业微信的应用id （e.g. 1000247）
        timestamp: data2.timestamp, // 必填，生成签名的时间戳
        nonceStr: data2.nonceStr, // 必填，生成签名的随机串
        signature: data2.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
        jsApiList: ['openExistedChatWithMsg', 'openEnterpriseChat', 'chooseImage', 'onMenuShareAppMessage'], // 必填，传入需要使用的接口名称
        success: function(res) {
            // 回调
            console.log(res);
        },
        fail: function(res) {
            console.log(res);
            // alert(JSON.stringify(res));
            if (res.errMsg.indexOf('function not exist') > -1) {
                // alert('版本过低请升级');
            }
        }
    });
};
